const BASE_ICON_URL = 'https://50277935.fs1.hubspotusercontent-na1.net/hubfs/50277935/assets/icons/apps/';
const AppDefinition = {
  asana: {
    displayName: 'Asana',
    iconUrl: `${BASE_ICON_URL}asana.svg`
  },
  azure_devops: {
    displayName: 'Azure DevOps',
    iconUrl: `${BASE_ICON_URL}azure_devops.svg`
  },
  box: {
    displayName: 'Box',
    iconUrl: `${BASE_ICON_URL}box.svg`
  },
  coda: {
    displayName: 'Coda',
    iconUrl: `${BASE_ICON_URL}coda.svg`
  },
  confluence: {
    displayName: 'Confluence',
    iconUrl: `${BASE_ICON_URL}confluence.svg`
  },
  document360: {
    displayName: 'Document360',
    iconUrl: `${BASE_ICON_URL}document360.svg`
  },
  docusign: {
    displayName: 'Docusign',
    iconUrl: `${BASE_ICON_URL}docusign.svg`
  },
  dropbox: {
    displayName: 'Dropbox',
    iconUrl: `${BASE_ICON_URL}dropbox.svg`
  },
  gcal: {
    displayName: 'Google Calendar',
    iconUrl: `${BASE_ICON_URL}gcal.svg`
  },
  gdocs: {
    displayName: 'Google Docs',
    iconUrl: `${BASE_ICON_URL}gdocs.webp`
  },
  gdrive: {
    displayName: 'Google Drive',
    iconUrl: `${BASE_ICON_URL}gdrive.svg`
  },
  gitbook: {
    displayName: 'GitBook',
    iconUrl: `${BASE_ICON_URL}gitbook.svg`
  },
  gmail: {
    displayName: 'Gmail',
    iconUrl: `${BASE_ICON_URL}gmail.svg`
  },
  gsheets: {
    displayName: 'Google Sheets',
    iconUrl: `${BASE_ICON_URL}gsheets.webp`
  },
  gslides: {
    displayName: 'Google Slides',
    iconUrl: `${BASE_ICON_URL}gslides.webp`
  },
  guru: {
    displayName: 'Guru',
    iconUrl: `${BASE_ICON_URL}guru.svg`
  },
  helpjuice: {
    displayName: 'Helpjuice',
    iconUrl: `${BASE_ICON_URL}helpjuice.svg`
  },
  intercom: {
    displayName: 'Intercom',
    iconUrl: `${BASE_ICON_URL}intercom.svg`
  },
  jira: {
    displayName: 'Jira',
    iconUrl: `${BASE_ICON_URL}jira.svg`
  },
  linear: {
    displayName: 'Linear',
    iconUrl: `${BASE_ICON_URL}linear.svg`
  },
  msteams: {
    displayName: 'Microsoft Teams',
    iconUrl: `${BASE_ICON_URL}msteams.svg`
  },
  onedrive: {
    displayName: 'OneDrive',
    iconUrl: `${BASE_ICON_URL}onedrive.svg`
  },
  outlook: {
    displayName: 'Outlook',
    iconUrl: `${BASE_ICON_URL}outlook.svg`
  },
  productboard: {
    displayName: 'Productboard',
    iconUrl: `${BASE_ICON_URL}productboard.svg`
  },
  readme: {
    displayName: 'ReadMe',
    iconUrl: `${BASE_ICON_URL}readme.svg`
  },
  sharepoint: {
    displayName: 'SharePoint',
    iconUrl: `${BASE_ICON_URL}sharepoint.svg`
  },
  slack: {
    displayName: 'Slack',
    iconUrl: `${BASE_ICON_URL}slack.svg`
  },
  smartsheet: {
    displayName: 'Smartsheet',
    iconUrl: `${BASE_ICON_URL}smartsheet.svg`
  },
  stackoverflowteams: {
    displayName: 'Stack Overflow for Teams',
    iconUrl: `${BASE_ICON_URL}stackoverflowteams.svg`
  },
  stripe: {
    displayName: 'Stripe',
    iconUrl: `${BASE_ICON_URL}stripe.svg`
  },
  zendesk: {
    displayName: 'Zendesk',
    iconUrl: `${BASE_ICON_URL}zendesk.svg`
  }
};
export const getAppInfo = appName => {
  return AppDefinition[appName] || {
    displayName: appName,
    iconUrl: `${BASE_ICON_URL}app.svg`
  };
};
export const getAppDisplayName = appName => {
  return getAppInfo(appName).displayName;
};
const SLACK = 'slack';
const GMAIL = 'gmail';
const GDRIVE = 'gdrive';
export const DEFAULT_APPS = [SLACK, GMAIL, GDRIVE];